import React, { ReactNode } from "react";
import { Drawer, Box } from "@mui/material";

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const CustomDrawer: React.FC<DrawerProps> = ({ open, onClose, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          height: "100%",
          borderTopLeftRadius: { xs: "0px", sm: "20px" },
          borderBottomLeftRadius: { xs: "0px", sm: "20px" },
          overflowX: "hidden",
          width: { xs: "100%", md: "640px" },
          maxWidth: "640px",
          backgroundColor: "#ffffff",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          height: "100%",
          display: "flex",
          width: "640px",
          maxWidth: "100%",
          flexDirection: "column",
          padding: "20px",
          gap: "24px",
          overflowY: "auto",
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default CustomDrawer;
